import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export function setUnrealHostIp(_json, userInfo){
    console.log("setUnrealHostIp " + userInfo.appId + " " + _json.setRoomIp);

    var hostIpRef = firebaseRef.ref("ongoing_meetings/" + PROJECT_CODE.projectCode  + "/" + userInfo.appId + "/hostIp");
    hostIpRef.set(_json.setRoomIp);
    hostIpRef.onDisconnect().set("");
    


}